import { Expose } from 'class-transformer';
import { DoorType } from './door-type';

export class DoorSpec {
    @Expose()
    doorNumber: number;
    @Expose()
    doorType: DoorType;
    @Expose()
    doorWidth?: number;
    @Expose()
    doorThresholdHeight?: number;
}
